<template>
  <div>
    <el-form ref="formRef" :model="formData" :rules="rules" label-position="top">
      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="名称：" prop="project_name">
            <el-input
              :controls="false"
              style="width:45%"
              size="small"
              v-model="formData.project_name"
              placeholder="请填写项目名称"
            ></el-input>

            <el-select
              v-model="formData.project_before_id"
              placeholder="请选择项目品牌"
              size="small"
              style="width:40%"
              @change="changeProject"
            >
              <el-option
                v-for="item in projectLists"
                :key="item.id"
                :label="item.project_name"
                :value="item.id"
              >
                <span style="float: left">{{ item.project_name }}</span>
                <span
                  style="float: right; color: red; font-size: 13px"
                  v-if="item.if_province == 1"
                >省区项目</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-alert
            title="项目描述："
            v-if="formData.project_before_id > 0"
            :description="pro_details.description"
            type="info"
            style="wdith:85%"
            :closable="false"
          ></el-alert>
        </el-col>
        <el-col :span="10">
          <el-form-item label="项目周期(月)：">
            <el-input
              :controls="false"
              disabled
              size="small"
              style="width:85%"
              v-model="formData.project_cycle"
              placeholder="根据项目起止日期自动计算周期"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="项目开始时间：" prop="regdate_start">
            <el-date-picker
              @change="getStartTime"
              v-model="formData.regdate_start"
              type="date"
              value-format="yyyy-MM-dd"
              size="small"
              style="width:85%"
              placeholder="选择项目开始时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="项目结束时间：" prop="regdate_end">
            <el-date-picker
              @change="getEndTime"
              v-model="formData.regdate_end"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:85%"
              size="small"
              placeholder="选择项目结束时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="预算总额：" prop="total_funds">
            <el-input v-model.number="formData.total_funds" size="small" style="width:85%" maxlength="9"></el-input>
          </el-form-item>

          <p v-if="DX(formData.total_funds)">人民币：{{DX(formData.total_funds)}}</p>
        </el-col>
        <el-col :span="10"></el-col>
      </el-row>

      <!-- <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="合作机构区域：" prop="cat_province_id" required>
            <el-select
              v-model="formData.cat_province_id"
              placeholder="选择省"
              size="small"
              style="width:32%"
              @change="getCity1"
              :disabled="province_id && province_id > 0 ?true:false"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="formData.cat_city_id"
              placeholder="选择市"
              @change="getCounty1"
              size="small"
              style="width:32%"
              :clearable="true"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in city1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="formData.cat_county_id"
              placeholder="选择区县"
              size="small"
              style="width:32%"
              :clearable="true"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in county1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="合作机构:" prop="cat_id">
            <el-select
              v-model="formData.cat_id"
              size="small"
              placeholder="请选择项目合作机构"
              style="width:85%"
            >
              <el-option
                v-for="item in cateData"
                :key="item.id"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>-->

      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form-item label="结算计划：" prop="payment_plan">
            <el-table :data="formData.payment_plan" border style="width:70%">
              <el-table-column prop="plan_time" label="日期">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="formData.payment_plan[scope.$index].plan_time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width:85%"
                    size="small"
                    placeholder="请选择日期"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column prop="plan_money" label="金额">
                <template slot-scope="scope">
                  <el-input-number
                    v-model="formData.payment_plan[scope.$index].plan_money"
                    controls-position="right"
                    :min="0"
                    :max="999999999"
                    size="small"
                    style="width:95%"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <el-button type="primary" size="small" @click="addPlanDrag">新增</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="delPlanDrag(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <p v-if="plan_total">
              <i class="el-icon-info"></i>计划总额：
              <span style="color:red">{{plan_total}}</span> 元
              <span
                style="display:inline-block;margin-left:20px;"
                v-if="plan_total_text && plan_total_text != ''"
              >人民币：{{plan_total_text}}</span>
            </p>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form-item label="救助对象" prop="fund_use">
            <el-input
              style="width:85%"
              v-model="formData.fund_use"
              placeholder
              :maxlength="500"
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center" style="padding:5px">
        <el-col :span="20">
          <el-divider>项目规模</el-divider>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form-item label="覆盖地域：" prop="address">
            <el-table border :data="formData.address">
              <el-table-column prop="province_data" label="省">
                <template slot-scope="scope">
                  <el-select
                    v-model="formData.address[scope.$index].province_id"
                    size="small"
                    placeholder="请选择省份"
                    @change="getCity($event,scope.$index)"
                  >
                    <el-option
                      v-for="item in provinceList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column prop="city_id" label="市">
                <template slot-scope="scope">
                  <el-select
                    v-model="formData.address[scope.$index].city_id"
                    size="small"
                    placeholder="请选择城市"
                    @change="getCounty($event,scope.$index)"
                    :clearable="true"
                  >
                    <el-option
                      v-for="item in cityList[scope.$index]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column prop="county_id" label="区/县">
                <template slot-scope="scope">
                  <el-select
                    v-model="formData.address[scope.$index].county_id"
                    size="small"
                    placeholder="请选择区县"
                    :clearable="true"
                  >
                    <el-option
                      v-for="item in countyList[scope.$index]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <el-button type="primary" size="small" @click="addAddressCol">新增</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="delAddressCol(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form-item label="项目预算：" prop="funds">
            <el-table border :data="formData.funds" style="width:821px">
              <el-table-column prop="cost_item" label="救助类别" width="200">
                <template slot-scope="scope">
                  <el-select
                    v-model="formData.funds[scope.$index].cost_item"
                    size="small"
                    placeholder="请选择救助类别"
                    :clearable="true"
                  >
                    <el-option
                      v-for="item in fundsProject"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column prop="money" label="金额" width="400">
                <template slot-scope="scope">
                  <el-select
                    v-model="formData.funds[scope.$index].unit"
                    size="small"
                    style="width:30%"
                    placeholder="选择单位"
                    :clearable="true"
                  >
                    <el-option
                      v-for="item in fundsUnit"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input-number
                    style="width:30%;padding-left:5px;"
                    :max="999999"
                    size="small"
                    controls-position="right"
                    v-model="formData.funds[scope.$index].funds_start"
                    :min="0"
                    placeholder="金额小"
                  ></el-input-number>&nbsp;&nbsp;-
                  <el-input-number
                    style="width:30%;padding-left:5px;"
                    :max="999999"
                    size="small"
                    controls-position="right"
                    v-model="formData.funds[scope.$index].funds_end"
                    :min="0"
                    placeholder="金额大"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="total_number" label="救助例数" width="120">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="formData.funds[scope.$index].total_number"
                    placeholder="救助例数"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <el-button type="primary" size="small" @click="addFundsDrag">新增</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="delFundsDrag(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center" style="padding:5px">
        <el-col :span="20">
          <el-divider>合作方信息</el-divider>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="合作方名称：" prop="collaborator_name">
            <el-input
              style="width: 80%"
              size="small"
              v-model="formData.collaborator_name"
              placeholder="请填写合作方名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="法人：" prop="corporation">
            <el-input
              style="width: 80%"
              size="small"
              v-model="formData.corporation"
              placeholder="请填写法人"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="联系人：" prop="contacts">
            <el-input
              :controls="false"
              style="width: 80%"
              size="small"
              v-model="formData.contacts"
              placeholder="请填写联系人"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="收款单位名称：" prop="payee_unit_name">
            <el-input
              :controls="false"
              style="width: 80%"
              size="small"
              v-model="formData.payee_unit_name"
              placeholder="请填写收款单位名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="收款单位联系人：" prop="payee_rela_user_name">
            <el-input
              :controls="false"
              style="width: 80%"
              size="small"
              v-model="formData.payee_rela_user_name"
              placeholder="请填写收款单位联系人"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="收款单位联系手机：" prop="payee_office_phone">
            <el-input
              :controls="false"
              style="width: 80%"
              size="small"
              v-model="formData.payee_office_phone"
              placeholder="请填写收款单位联系手机"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="收款单位开户行：" prop="bank_name">
            <el-input
              :controls="false"
              style="width: 80%"
              size="small"
              v-model="formData.bank_name"
              placeholder="请填写收款单位开户行"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="收款单位开户名：" prop="account_name">
            <el-input
              :controls="false"
              style="width: 80%"
              size="small"
              v-model="formData.account_name"
              placeholder="请填写收款单位开户名"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="收款单位账号：" prop="account_number">
            <el-input
              :controls="false"
              style="width: 80%"
              size="small"
              v-model.trim="formData.account_number"
              placeholder="请填写收款单位账号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="业务范围：" prop="business_scope">
            <el-input
              style="width:80%"
              v-model="formData.business_scope"
              placeholder
              :maxlength="300"
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
export default {
  props: {
    // 项目id
    id: {
      type: Number,
      default: 0,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    var checkProName = (rule, value, callback) => {
      if (!this.formData.project_name) {
        return callback(new Error("请填写项目名称！"));
      } else if (!(this.formData.project_before_id > 0)) {
        return callback(new Error("请选择项目品牌！"));
      }
      return callback();
    };
    // var regionGroup = (rule, value, callback) => {
    //   if (!(this.formData.cat_province_id > 0)) {
    //     return callback(new Error("请选择合作机构省！"));
    //   } else if (!(this.formData.cat_city_id > 0)) {
    //     return callback(new Error("请选择合作机构市！"));
    //   } else if (!(this.formData.cat_county_id > 0)) {
    //     return callback(new Error("请选择合作机构区县！"));
    //   }
    //   return callback();
    // };

    var checkPhone = (rule, value, callback) => {
      if (this.formData.payee_office_phone) {
        let mobile = /^[1][0-9]{10}$/;
        if (!mobile.test(this.formData.payee_office_phone)) {
          return callback(new Error("手机号格式不正确！"));
        }
      } else {
        return callback(new Error("请填写收款单位手机号！"));
      }
      return callback();
    };

    var checkAddressGroup = (rule, value, callback) => {
      if (
        typeof this.formData.address === "undefined" ||
        this.formData.address.length === 0
      ) {
        // return callback(new Error("请选择项目范围！"));
      } else {
        let len = this.formData.address.length;
        if (
          len > 0 &&
          !this.formData.address[len - 1].province_id &&
          !this.formData.address[len - 1].city_id
        ) {
          return callback(new Error("请完善第" + len + "条项目范围信息！"));
        }
      }
      return callback();
    };

    var planGroup = (rule, value, callback) => {
      if (typeof this.formData.payment_plan === "undefined") {
        return callback(new Error("请添加结算计划！"));
      } else {
        if (this.formData.payment_plan.length === 0) {
          return callback(new Error("请添加结算计划！"));
        } else {
          this.formData.payment_plan.forEach((item, index) => {
            let num = index + 1;
            if (!item.plan_time) {
              return callback(new Error("请选择" + num + "条捐款时间！"));
            } else if (!item.plan_money || !(parseFloat(item.plan_money) > 0)) {
              return callback(new Error("请填写" + num + "条捐款金额！"));
            }
          });
        }
      }
      return callback();
    };

    var fundsGroup = (rule, value, callback) => {
      let arr = [];
      if (typeof this.formData.funds === "undefined") {
        return callback(new Error("请填写项目预算！"));
      } else {
        if (this.formData.funds.length === 0) {
          return callback(new Error("请填写项目预算！"));
        } else {
          this.formData.funds.forEach((item, index) => {
            let num = index + 1;
            if (!item.cost_item) {
              return callback(new Error("请填写第" + num + "条信息费用项目"));
            } else if (!item.unit) {
              return callback(new Error("请选择第" + num + "条单位信息"));
            } else if (!(item.funds_start >= 0)) {
              return callback(new Error("请填写第" + num + "条金额小"));
            } else if (!(item.funds_end >= 0)) {
              return callback(new Error("请填写第" + num + "条金额大"));
            } else if (item.funds_start > item.funds_end) {
              return callback(new Error("第" + num + "条金额区间有误"));
            } else if (!Number(item.total_number >= 0)) {
              return callback(new Error("第" + num + "条救助例数"));
            }
            arr[index] = item.cost_item;
          });
        }
      }
      this.formData.salvage_ids = arr;
      return callback();
    };

    return {
      type: 1, //项目类型  1自由项目  2合作项目

      pro_details: {}, //获取的项目详情
      uploadFileUrl: "", //上传文件接口url

      city1: [], //项目执行区域
      county1: [], //项目执行区域

      cityList: [], //省数据
      provinceList: [], //市数据
      countyList: [], //区数据

      province_id: null, //省区项目省区

      cateData: [], //项目合作分类
      fundsProject: [], //费用项目
      fundsUnit: [], //费用单位

      projectLists: [], //项目列表
      cateDisabled: false, //是否禁用体系
      dateDisabled: false, //是否禁用项目时间

      // fundsTypeData: [], //资源类型
      // sourceData: [], //资源来源
      endTimeOption: {}, //结束时间参数配置
      startTimeOption: {}, //开始时间参数配置

      // salvageData: [], //救助领域
      financialType1: [], //大类
      financialType2: [], //小类

      plan_total_text: "", //结算计划人民币中文金额
      total_funds_text: "", //预算总额人民币金额

      formData: {
        project_before_id: null, //项目id
        project_name: null, //项目名称
        // cat_id: null, //合作机构
        project_funds_type: 2, //项目类型 自有项目
        // cat_province_id: null, //合作机构区域省
        cat_city_id: null, //合作机构市
        cat_county_id: null, //合作机构区县
        payment_plan: [], //结算计划
        // return_agreement_id: null, //回捐协议附件
        // return_agreement_id_path: [], //回捐协议附件 编辑数据
        regdate_start: null, //项目开始时间
        regdate_end: null, //项目结束时间
        project_cycle: null, //项目周期
        // beneficiary_number: null, //受益群体人数
        total_funds: null, //预算金额
        // per_medicare_income: null, //医保收入占医保额度
        address: [], //覆盖地域
        funds: [], //项目预算
        fund_use: "", //救助对象描述
        salvage_ids: [], //救助领域
        collaborator_name: "",
        corporation: null,
        contacts: null,
        payee_unit_name: null,
        payee_rela_user_name: null,
        payee_office_phone: null,
        bank_name: null,
        account_name: null,
        account_number: null,
        business_scope: null,
        finance: {
          collaborator_name: null,
          corporation: null,
          contacts: null,
          payee_unit_name: null,
          payee_rela_user_name: null,
          payee_office_phone: null,
          bank_name: null,
          account_name: null,
          account_number: null,
          business_scope: null,
        },
      },

      rules: {
        project_before_id: [
          {
            required: true,
            type: "number",
            message: "请选择项目",
            trigger: "blur",
          },
        ],

        project_name: [
          {
            required: true,
            message: "请填写项目名称！",
            trigger: "blur",
          },
          { validator: checkProName },
        ],

        // cat_id: [
        //   {
        //     required: true,
        //     type: "number",
        //     message: "请选择项目合作机构",
        //     trigger: "change"
        //   }
        // ],
        // cat_province_id: [
        //   { validator: regionGroup, trigger: "blur" },
        //   { required: true, message: "请填写机构合作区域！", trigger: "change" }
        // ],

        hospital_medical_insurance_quota: [
          {
            required: true,
            message: "请填写执行机构全年医保额度",
            trigger: "blur",
          },
        ],
        // per_medicare_income: [
        //   {
        //     required: true,
        //     message: "请填写项目医保收入占医保额度",
        //     trigger: "blur"
        //   }
        // ],

        regdate_start: [
          { required: true, message: "请选择项目开始时间", trigger: "blur" },
        ],
        regdate_end: [
          { required: true, message: "请选择项目结束时间", trigger: "blur" },
        ],
        // beneficiary_number: [
        //   { required: true, message: "请填写受益群体人数", trigger: "blur" }
        // ],
        total_funds: [
          {
            required: true,
            type: "number",
            message: "请填写预算总额",
            trigger: "blur",
          },
        ],
        project_summary: [
          { required: true, message: "请填写项目背景", trigger: "blur" },
        ],

        address: [
          // {
          //   required: true,
          //   type: "array",
          //   message: "覆盖范围不能为空！",
          //   trigger: "change"
          // },
          { validator: checkAddressGroup, trigger: "change" },
        ],

        payment_plan: [
          { validator: planGroup, trigger: "blur" },
          { required: true, message: "请填写结算计划！", trigger: "change" },
        ],
        // salvage_ids: [
        //   { required: true, message: "请选择救助领域", trigger: "change" }
        // ],
        funds: [
          { validator: fundsGroup, trigger: "change" },
          { required: true, message: "请填写项目预算", trigger: "change" },
        ],
        fund_use: [
          {
            required: true,
            message: "请填写救助救助对象",
            trigger: "blur",
          },
        ],

        collaborator_name: [
          { required: true, message: "请填写合作方名称！", trigger: "blur" },
        ],
        corporation: [
          {
            required: true,
            message: "请填写法人！",
            trigger: "blur",
          },
        ],
        contacts: [
          {
            required: true,
            message: "请填写收款单位联系人！",
            trigger: "blur",
          },
        ],
        payee_rela_user_name: [
          {
            required: true,
            message: "请填写收款单位联系人！",
            trigger: "blur",
          },
        ],
        payee_unit_name: [
          {
            required: true,
            message: "请填写收款名称！",
            trigger: "blur",
          },
        ],
        payee_office_phone: [
          {
            required: true,
            message: "收款单位联系手机不能为空！",
            trigger: "blur",
          },
          { validator: checkPhone, trigger: "blur" },
        ],
        // payee_telephone: [{ validator: checkPhone, trigger: "blur" }],
        bank_name: [
          {
            required: true,
            message: "请填写收款单位开户行！",
            trigger: "blur",
          },
        ],
        account_name: [
          {
            required: true,
            message: "请填写收款单位开户名称！",
            trigger: "blur",
          },
        ],
        account_number: [
          { required: true, message: "请填写收款单位账号！", trigger: "blur" },
        ],

        // business_scope: [
        //   { required: true, message: "请填写业务范围！", trigger: "blur" }
        // ]
      },
    };
  },
  methods: {
    //获取预算总额人民币
    getMoneyText(val) {
      if (Number(this.formData.total_funds) > 0) {
        this.total_funds_text = this.DX(this.formData.total_funds);
      } else {
        this.total_funds_text = "";
      }
    },
    //根据项目获取不同信息
    changeProject(val, ifEdit = false) {
      if (val) {
        this.$db
          .post(this.$db.config.com_project.approval.own_pro_info, { id: val })
          .then((res) => {
            this.pro_details = res.data;
          });
      }
    },

    //提交表单操作
    submitF() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          this.formData.finance.collaborator_name = this.formData.collaborator_name;
          this.formData.finance.corporation = this.formData.corporation;
          this.formData.finance.contacts = this.formData.contacts;
          this.formData.finance.payee_unit_name = this.formData.payee_unit_name;
          this.formData.finance.payee_rela_user_name = this.formData.payee_rela_user_name;
          this.formData.finance.payee_office_phone = this.formData.payee_office_phone;
          this.formData.finance.bank_name = this.formData.bank_name;
          this.formData.finance.account_name = this.formData.account_name;
          this.formData.finance.account_number = this.formData.account_number;
          this.formData.finance.business_scope = this.formData.business_scope;

          if (this.$route.query.id > 0 || this.id > 0) {
            //编辑操作
            if (this.id > 0) {
              //判断是否有id
              this.formData.id = this.id;
            }
            this.$db
              .post(
                this.$db.config.com_project.approval.first_edit,
                this.formData
              )
              .then((res) => {
                if (res.code == 200) {
                  this.$emit("callback", res.data);
                }
              });
          } else {
            //新增操作
            this.$db
              .post(
                this.$db.config.com_project.approval.first_add,
                this.formData
              )
              .then((res) => {
                if (res.code == 200) {
                  this.$emit("callback", res.data);
                }
              });
          }
        } else {
          return this.$message.warning("请填写完整表单信息！");
        }
      });
    },

    // //项目预算选择费用change事件
    // changeSalvage() {
    //   let arr = [];

    //   this.formData.funds.forEach((item, index) => {
    //     if (arr.indexOf(item.cost_item) == -1) {
    //       arr.push(item.cost_item);
    //     }
    //   });
    //   this.formData.salvage_ids = arr;
    // },

    getIntervalMonth() {
      var startMonth = new Date(Date.parse(this.formData.regdate_start));
      var endMonth = new Date(Date.parse(this.formData.regdate_end));
      var intervalMonth =
        endMonth.getFullYear() * 12 +
        endMonth.getMonth() -
        (startMonth.getFullYear() * 12 + startMonth.getMonth());
      var day = endMonth.getDate() - startMonth.getDate();
      if (day > 0) {
        intervalMonth += 1;
      }
      intervalMonth > 0 && (this.formData.project_cycle = intervalMonth);
    },

    //资金筹集-截止时间判断 未使用结束
    getStartTime() {
      //项目开始时间事件
      if (this.formData.regdate_end) {
        let regdate_start = new Date(Date.parse(this.formData.regdate_start));
        let regdate_end = new Date(Date.parse(this.formData.regdate_end));

        if (regdate_end < regdate_start) {
          this.formData.regdate_start = "";
          this.$message({
            type: "warning",
            message: "项目开始时间不能大于项目结束时间！",
          });
        } else {
          this.getIntervalMonth();
        }
      }
    },

    getEndTime() {
      //项目结束时间事件
      if (this.formData.regdate_start) {
        let regdate_start = new Date(Date.parse(this.formData.regdate_start));
        let regdate_end = new Date(Date.parse(this.formData.regdate_end));

        if (regdate_end < regdate_start) {
          this.formData.regdate_end = "";
          this.$message({
            type: "warning",
            message: "项目开始时间不能大于项目结束时间！",
          });
        } else {
          this.getIntervalMonth();
        }
      }
    },

    //千分化金额
    setMoneyFormat(num) {
      return (Number(num).toFixed(2) + "").replace(
        /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
        "$&,"
      );
    },

    //金额转成大写
    DX(n) {
      if (Number(n) > 0) {
        if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "";
        var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
          str = "";
        n += "00";
        var p = n.indexOf(".");
        if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
        unit = unit.substr(unit.length - n.length);
        for (var i = 0; i < n.length; i++)
          str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
        return str
          .replace(/零(仟|佰|拾|角)/g, "零")
          .replace(/(零)+/g, "零")
          .replace(/零(万|亿|元)/g, "$1")
          .replace(/(亿)万|壹(拾)/g, "$1$2")
          .replace(/^元零?|零分/g, "")
          .replace(/元$/g, "元整");
      } else {
        return false;
      }
    },

    //增加结算计划
    addPlanDrag() {
      let pushArr = {
        plan_time: null,
        plan_money: null,
      };

      let len = this.formData.payment_plan.length;

      if (len && len > 0) {
        if (
          !this.formData.payment_plan[len - 1].plan_time ||
          !(this.formData.payment_plan[len - 1].plan_money > 0)
        ) {
          return this.$message.warning("请先完善上一行信息，再执行该操作！");
        }
      }

      this.formData.payment_plan.push(pushArr);
    },

    //删除结算计划
    delPlanDrag(index) {
      this.formData.payment_plan.splice(index, 1);
    },

    //增加覆盖地域
    addAddressDrag() {
      let pushArr = {
        province_id: this.province_id ? this.province_id : null,
        city_id: null,
        county_id: null,
      };
      this.formData.address.push(pushArr);
    },

    //删除覆盖地域
    delAddressDrag(index) {
      this.formData.address.splice(index, 1);
    },

    //项目预算
    addFundsDrag() {
      let pushArr = {
        cost_item: null,
        unit: null,
        funds_start: "",
        funds_end: "",
        total_number: 0,
      };
      this.formData.funds.push(pushArr);
    },

    //项目预算删除
    delFundsDrag(index) {
      this.formData.funds.splice(index, 1);
    },

    //获取项目列表
    getProjectLists() {
      this.$db
        .post(this.$db.config.com_project.approval.pro_list, {
          type: this.$route.query.type,
          status: 1,
        })
        .then((res) => {
          if (res.code == 200) {
            this.projectLists = res.data;
          }
        });
    },

    //合作机构区域
    getCity1(value, isEdit = false) {
      if (!isEdit) {
        this.formData.cat_city_id = null;
        this.formData.cat_county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 2, pid: value })
        .then((res) => {
          if (res && res.code == 200) {
            this.city1 = res.data;
          }
        });
    },

    getCounty1(value, isEdit = false) {
      if (!isEdit) {
        this.formData.cat_county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 3, pid: value })
        .then((res) => {
          if (res && res.code == 200) {
            this.county1 = res.data;
          }
        });
    },

    //市
    getCity(val, index, if_edit = false) {
      if (!if_edit) {
        this.formData.address[index].city_id = null;
        this.formData.address[index].city_id_text = null;
        this.formData.address[index].county_id = null;
        this.formData.address[index].county_id_text = null;
      }

      let params = { level: 2, pid: val };
      this.$db.post(this.$db.config.getRegionUrl, params).then((resp) => {
        if (resp && resp.code == 200) {
          if (index >= 0) {
            this.$set(this.cityList, index, resp.data);
          }
        }
      });
    },
    //县
    getCounty(val, index, if_edit = false) {
      if (!if_edit) {
        this.formData.address[index].county_id = null;
        this.formData.address[index].county_id_text = null;
      }

      let params = { level: 3, pid: val };
      this.$db.post(this.$db.config.getRegionUrl, params).then((resp) => {
        if (resp && resp.code == 200) {
          if (index >= 0) {
            this.$set(this.countyList, index, resp.data);
          }
        }
      });
    },

    //增加项目范围
    addAddressCol() {
      let len = this.formData.address.length;

      if (len && len > 0) {
        if (!this.formData.address[len - 1].province_id) {
          return this.$message.warning("请先完善上一行信息，再执行该操作！");
        }
      }
      let pushArr = {
        province_id: null,
        city_id: null,
        county_id: null,
      };
      this.formData.address.push(pushArr);
    },
    //删除项目范围
    delAddressCol(index) {
      this.formData.address.splice(index, 1);
    },

    //查询相关的字典数据
    getDictParamInfo() {
      //合作机构
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100180,
          table: "pub_type_param",
        })
        .then((res) => {
          if (res.code == 200) {
            this.cateData = res.data;
          }
        });
      //费用项目
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100170,
          table: "pub_type_param",
        })
        .then((res) => {
          if (res.code == 200) {
            this.fundsProject = res.data;
          }
        });
      //费用单位
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100310,
          table: "pub_type_param",
        })
        .then((res) => {
          if (res.code == 200) {
            this.fundsUnit = res.data;
          }
        });

      //获取财务预算 大小类
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 200570,
          table: "pub_dict",
        })
        .then((res) => {
          if (res.code == 200) {
            this.financialType1 = res.data;
          }
        });
    },

    //处理编辑数据
    getEditInfo() {
      //编辑数据
      this.$db
        .post(this.$db.config.com_project.approval.detail, {
          id: this.$route.query.id,
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.formData = res.data;

            this.$set(
              this.formData,
              "collaborator_name",
              res.data.finance.collaborator_name
            );
            // this.formData.collaborator_name =
            //   res.data.finance.collaborator_name;
            this.$set(
              this.formData,
              "corporation",
              res.data.finance.corporation
            );
            // this.formData.corporation = res.data.finance.corporation;
            this.$set(this.formData, "contacts", res.data.finance.contacts);
            // this.formData.contacts = res.data.finance.contacts;
            this.$set(
              this.formData,
              "payee_unit_name",
              res.data.finance.payee_unit_name
            );
            // this.formData.payee_unit_name = res.data.finance.payee_unit_name;
            this.$set(
              this.formData,
              "payee_rela_user_name",
              res.data.finance.payee_rela_user_name
            );
            // this.formData.payee_rela_user_name =
            //   res.data.finance.payee_rela_user_name;
            this.$set(
              this.formData,
              "payee_office_phone",
              res.data.finance.payee_office_phone
            );
            // this.formData.payee_office_phone =
            //   res.data.finance.payee_office_phone;
            this.$set(this.formData, "bank_name", res.data.finance.bank_name);
            // this.formData.bank_name = res.data.finance.bank_name;
            this.$set(
              this.formData,
              "account_name",
              res.data.finance.account_name
            );
            // this.formData.account_name = res.data.finance.account_name;
            this.$set(
              this.formData,
              "account_number",
              res.data.finance.account_number
            );
            // this.formData.account_number = res.data.finance.account_number;
            this.$set(
              this.formData,
              "business_scope",
              res.data.finance.business_scope
            );
            // this.formData.business_scope = res.data.finance.business_scope;

            this.changeProject(res.data.project_before_id, true);
            this.formData.total_funds = Number(res.data.total_funds);
            if (this.formData.total_funds) {
              this.total_funds_text = this.DX(this.formData.total_funds);
            }

            // if (res.data.cat_city_id > 0 && res.data.cat_province_id > 0) {
            //   this.formData.cat_province_id = res.data.cat_province_id;
            //   this.getCity1(res.data.cat_province_id, true);
            //   this.getCounty1(res.data.cat_city_id, true);
            //   this.formData.cat_city_id = res.data.cat_city_id;
            // }

            if (res.data.address && res.data.address.length > 0) {
              this.formData.address.forEach((item, index) => {
                if (res.data.address[index].province_id) {
                  this.formData.address[index].province_id =
                    res.data.address[index].province_id;
                }

                if (res.data.address[index].city_id) {
                  this.getCity(
                    res.data.address[index].province_id,
                    index,
                    true
                  );
                  this.formData.address[index].city_id =
                    res.data.address[index].city_id;
                }

                if (res.data.address[index].county_id) {
                  this.getCounty(res.data.address[index].city_id, index, true);
                  this.formData.address[index].county_id =
                    res.data.address[index].county_id;
                }
              });
            }
          }
        });
    },
  },
  computed: {
    plan_total: {
      get: function () {
        let num = null;
        if (
          this.formData.payment_plan &&
          this.formData.payment_plan.length > 0
        ) {
          this.formData.payment_plan.forEach((item) => {
            num += Number(item.plan_money);
          });
          this.plan_total_text = this.DX(num);
          return this.setMoneyFormat(num);
        }
      },
    },
  },
  watch: {
    // plan_total(value) {
    //   if (value > 0) {
    //     this.plan_total_text = this.DX(value);
    //   } else {
    //     this.plan_total_text = "";
    //   }
    // }
  },
  mounted() {
    this.formData.project_before_type = this.$route.query.type;
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
    this.getDictParamInfo();
    this.getProjectLists();
    //省
    this.$db.post(this.$db.config.getRegionUrl, { level: 1 }).then((resp) => {
      if (resp && resp.code == 200) {
        this.provinceList = resp.data;
      }
    });

    if (this.$route.query.id > 0) {
      this.getEditInfo();
    }
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Hospital/comproject/approval/step/first1.vue